export default __webpack_public_path__ + "46487035fda25b91eea8c8558f572b1c.svg";